import { AxiosResponse } from 'axios';
import settings from '../settings';
import { ISeason } from '../types';
import api from './base';

export function getSeasonById(id: number): Promise<AxiosResponse<ISeason>> {
  const uri = `${settings.getApiURI()}/story/v1/seasons/${id}`;
  return api.http.get(uri);
}
